import { analyticsService, flagService } from '../core/services';
import * as gtag from './services/gtag';

let gaEventCounter = 0;
let gaTrackerCount = 1;
let gaClientSessionEventLimit = 450;

const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';
let lastPageTitle: string;

const {
  initialize: gtagInit,
  exception,
  event,
  eCommerce,
  pageAndScreenView,
} = gtag;

function initialize(
  extraTrackers: Parameters<typeof gtagInit>[0],
  disable: boolean,
): void {
  try {
    if (extraTrackers.length > 1) {
      gaTrackerCount = extraTrackers.length;
      gaClientSessionEventLimit /= gaTrackerCount;
    }

    gtagInit(extraTrackers, disable);
    // fix 'Event hits must be sent after a pageview hit, but this event hit was not preceded by a pageview'
    lastPageTitle = lastPageTitle || getTitleFromRoute(window.location.hash);
    pageAndScreenView(lastPageTitle);
  } catch (error) {
    console.log(error);
  }
}

export { eCommerce, event, exception, initialize };

const TITLE_ROUTE_CONFIG: Array<{ title: string; route: RegExp }> = [
  { title: 'Map Screen', route: /^#\/where/ },
  { title: 'Confirm Address Screen', route: /^#\/delivery\/confirm/ },
  {
    title: 'Delivery/Collection Restaurants List',
    route: /^#\/(collection|delivery)\//,
  },
  { title: 'Phone Number Screen', route: /^#\/phone/ },
  {
    title: 'Restaurant Menu Options Screen',
    route: /^#\/restaurant\/.*\/configure\/[0-9]*\/0$/,
  },
  {
    title: 'Restaurant Menu Screen',
    route: /^#\/restaurant\//,
  },
  { title: 'SMS Code Screen', route: /^#\/code\// },
  { title: 'Payments Screen', route: /^#\/payment\// },
  { title: 'Add New Card Screen', route: /^#\/card\// },
  { title: 'Checkout Screen', route: /^#\/checkout\// },
  { title: 'Add Voucher Screen', route: /^#\/voucher\// },
  { title: 'Order Placed Screen', route: /^#\/order\// },
];
function getTitleFromRoute(hashRoute: string) {
  try {
    const { title } = TITLE_ROUTE_CONFIG.find(({ route }) =>
      route.test(hashRoute),
    );
    return title;
  } catch (error) {
    return '';
  }
}

export const PageView = () => {
  const title = getTitleFromRoute(window.location.hash);

  if (lastPageTitle === title || !title) {
    // stops Google Analytics firing twice!
    return;
  }

  lastPageTitle = title;

  gaEventCounter += 1;
  if (gaEventCounter < gaClientSessionEventLimit) {
    gtag.pageAndScreenView(title);
  }
};

interface TrackProperties {
  [s: string]: string | number | boolean | undefined | Record<string, unknown>;
}

export const Track = (
  category: string,
  action: string,
  props: TrackProperties = {},
  pixelStandardEventName = '',
): void => {
  try {
    const isPixelStandardEventsEnabled = flagService.isFlagOn(
      'pixelStandardEvents',
    );

    const isPurchaseEvent = category === 'Orders' && action === 'Place Order';
    if (isPurchaseEvent) {
      gaEventCounter = 0;
    } else {
      gaEventCounter += 1;
    }

    if (gaEventCounter < gaClientSessionEventLimit) {
      gtag.event(category, action, props);
    }

    const hasProps = Object.keys(props).length > 0;

    const analyticsProps = (
      hasProps ? { ...props } : { label: action, section: category }
    ) as TrackProperties;

    if (pixelStandardEventName && isPixelStandardEventsEnabled) {
      analyticsProps.label = pixelStandardEventName;
      analyticsProps.isPixelStandardEvent = true;
    }

    analyticsService.track(analyticsProps);

    if (!isProduction) {
      // console.log(
      //   '[Track] - disabled outside production!',
      //   category,
      //   action,
      //   props,
      // );
      return;
    }
  } catch (e) {
    console.error('Error sending event', e);
  }
};
